// Map a server-side role string to the i18n key under "team.role.*". Owner
// and Admin map 1:1; editor/viewer/anything-else collapses to "member" since
// the UI doesn't surface a viewer/editor distinction in this view.

import type { TeamRole } from "./types";

const ROLE_KEY: Record<string, "owner" | "admin" | "member"> = {
  owner: "owner",
  admin: "admin",
  editor: "member",
  viewer: "member",
};

export function getTeamRoleI18nKey(role: TeamRole | string | undefined): string {
  if (!role) return "team.role.member";
  return `team.role.${ROLE_KEY[role] ?? "member"}`;
}
